/* TypeScript file generated from CountBadge.resi by genType. */

/* eslint-disable */
/* tslint:disable */

import * as CountBadgeJS from './CountBadge.res.js';

export type variation = "ghost" | "outline" | "solid";

export type size = "large" | "medium" | "small";

export type tone = "brand" | "neutral";

export type props<children,size,variation,tone,accent> = {
  readonly children: children; 
  readonly size?: size; 
  readonly variation?: variation; 
  readonly tone?: tone; 
  readonly accent?: accent
};

export const make: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly size?: size; 
  readonly variation?: variation; 
  readonly tone?: tone; 
  readonly accent?: boolean
}> = CountBadgeJS.make as any;
